import { Value } from 'formulascript/interpreter';

import { wrapFunction } from '../utils';

export const RANDOMIZE = (array: Value[]): Value[] => {
  if (!Array.isArray(array)) {
    throw new Error('RANDOMIZE expects an array as the first argument');
  }

  const copy = structuredClone(array);
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy;
};

export default wrapFunction(RANDOMIZE, {
  name: 'RANDOMIZE',
  nargs: 1,
  types: ['array'],
});
